import { render } from "./accountDetails.vue?vue&type=template&id=7e053aa0&scoped=true"
import script from "./accountDetails.vue?vue&type=script&lang=js"
export * from "./accountDetails.vue?vue&type=script&lang=js"

import "./accountDetails.vue?vue&type=style&index=0&id=7e053aa0&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e053aa0"]])

export default __exports__